import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  SmartAlert,
  SmartFormInterFace,
  SmartLoaderInterface,
  SmartSoftButton,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { INVOICE_URLS } from "../../api/UserUrls";
import config from "../../config/config";
import { useSiteContext } from "../../contexts/SiteProvider";
import {
  changeDateTimeZoneFormat,
  formatCurrency,
} from "../../services/core/CommonService";
import { downloadFile } from "../../services/core/FileService";
import { openExternalWindow } from "../../services/core/WindowService";
import { showAlertAutoClose } from "../../services/notifyService";
import { post } from "../../services/smartApiService";
import InvoiceAddingForm from "./InvoiceAddingForm";
import InvoiceNumberUpdate from "./InvoiceNumberUpdate";
import InvoiceRemarks from "./InvoiceRemarks";
import InvoiceVendorDetailsTable from "./InvoiceVendorDetailsTable";
import VendorDetailsImport from "./VendorDetailsImport";
import "./TabsComponent.scss";
import { motion } from "framer-motion";

const VendorWiseInformation = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const invoice_ret_id = searchParams.get("invoice_id");
  const [data, setData] = useState<any>({});
  const { openModal, isDark, closeModal } = useSiteContext();
  const navigate = useNavigate();
  const loadData = () => {
    let URL = INVOICE_URLS.GET_ONE_BILL;
    const subscription = post(URL, { id: id }).subscribe((response) => {
      setData(response.data);
      //console.log("response data", response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const deleteData = (invoice_id: any) => {
    const subscription = post(INVOICE_URLS.INVOICE_DELETE, {
      id: invoice_id,
    }).subscribe((response) => {
      showAlertAutoClose("Deleted Successfully...", "success");
      loadData();
      // setLoading(false);
    });
    return () => {
      subscription.unsubscribe();
    };
  };
  const CancelInvoice = (invoice_id: any) => {
    const subscription = post(INVOICE_URLS.CANCEL_INVOICE, {
      id: invoice_id,
    }).subscribe((response) => {
      showAlertAutoClose(
        "The invoice has been canceled successfully.",
        "success"
      );
      loadData();
      // setLoading(false);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openDeleteModal = (invoice_id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: "Invoice Deletion?",
      alertFunction: (option) => {
        if (option == "yes") {
          deleteData(invoice_id);
          SmartAlert.hide();
        }
      },
      content: <p>Note: Do you wish to delete this Invoice</p>,
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };
  const openCancelModal = (invoice_id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: "Invoice Cancel?",
      alertFunction: (option) => {
        if (option == "yes") {
          CancelInvoice(invoice_id);
          SmartAlert.hide();
        }
      },
      content: <p>Note: Do you wish to cancel this Invoice</p>,
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  const refresh = () => {
    let URL = INVOICE_URLS.REFRESH;
    const subscription = post(URL, { id: id }).subscribe((response) => {
      //setData(response.data);
      loadData();
      //console.log("response data", response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };
  const tabData = [
    { title: "Active Invoices", value: "1" },
    { title: "Cancelled Invoices", value: "2" },
  ];
  const [activeIndex, setActiveIndex] = useState<any>("1");
  const [selectedState, setSelectedState] = useState<string | null>(null);
  const [selectedRange, setSelectedRange] = useState<string | null>(null);
  const [selectedInvoiceType, setSelectedInvoiceType] = useState<number | null>(null);

  const invoiceTypeOptions = [
    { label: "All", value: null },
    { label: "Automatic", value: 1 },
    { label: "Manual Invoice", value: 2 },
    { label: "Credit Note", value: 3 },
  ];

  const getStateGroups = () => {
    const invoices = data.invoice_data || [];
    const groups: { [key: string]: { min: number; max: number; count: number } } = {};
    invoices.forEach((inv: any) => {
      const state = inv.state_name;
      const serial = parseInt(inv.invoice_serial_number);
      if (!state || isNaN(serial)) return;
      if (!groups[state]) {
        groups[state] = { min: serial, max: serial, count: 1 };
      } else {
        groups[state].min = Math.min(groups[state].min, serial);
        groups[state].max = Math.max(groups[state].max, serial);
        groups[state].count += 1;
      }
    });
    return Object.entries(groups).map(([state_name, { min, max, count }]) => ({
      state_name,
      range: min === max ? `${min}` : `${min}-${max}`,
      count,
    }));
  };

  const getFilteredInvoiceData = () => {
    let invoices: any[] = data.invoice_data || [];
    if (selectedInvoiceType !== null) {
      invoices = invoices.filter((inv: any) => inv.invoice_type === selectedInvoiceType);
    }
    if (selectedState) {
      invoices = invoices.filter((inv: any) => inv.state_name === selectedState);
    }
    if (selectedRange) {
      const parts = selectedRange.split("-");
      if (parts.length === 2) {
        const min = parseInt(parts[0]);
        const max = parseInt(parts[1]);
        invoices = invoices.filter((inv: any) => {
          const serial = parseInt(inv.invoice_serial_number);
          return serial >= min && serial <= max;
        });
      }
    }
    return invoices;
  };

  const InvoiceTypeFilter = () => (
    <div className="tabs is-toggle is-small custom-tabs" style={{ marginBottom: 0 }}>
      <ul>
        {invoiceTypeOptions.map((opt) => (
          <li
            key={String(opt.value)}
            className={selectedInvoiceType === opt.value ? "is-active" : ""}
            style={{ cursor: "pointer" }}
            onClick={() => setSelectedInvoiceType(opt.value)}
          >
            <a><span>{opt.label}</span></a>
          </li>
        ))}
      </ul>
    </div>
  );

  const TabsComponent = () => {
    return (
      <div className="is-flex is-align-items-center" style={{ gap: "0.5rem" }}>
        <div className="tabs-container mx-2">
          <div className="tabs is-toggle is-fullwidth custom-tabs is-small">
            <ul>
              {tabData.map((tab) => (
                <motion.li
                  key={tab.value}
                  className={activeIndex === tab.value ? "is-active" : ""}
                  onClick={() => setActiveIndex(tab.value)}
                  layout
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                >
                  <a>
                    <span>{tab.title}</span>
                  </a>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
        <InvoiceTypeFilter />
      </div>
    );
  };

  const exportExcel = () => {
    let URL = INVOICE_URLS.EXPORT_EXCEL;
    const subscription = post(URL, { id: id }).subscribe((response) => {
      if (response.data && response.data.content) {
        downloadFile(response.data.content, "bill.xlsx");
      }
      //console.log(response);
      //setData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const downloadInvoice = (invoice_id: number) => {
    let URL = INVOICE_URLS.DOWNLOAD_INVOICE;
    const subscription = post(URL, { id: invoice_id }).subscribe((response) => {
      if (response.data && response.data.content) {
        let file_name = response.data.file_name
          ? response.data.file_name
          : "invoice.pdf";
        downloadFile(response.data.content, file_name);
      }
      //console.log(response);
      //setData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const downloadZip = () => {
    let URL = INVOICE_URLS.EXPORT_ZIP;
    const subscription = post(URL, { id: id }).subscribe((response) => {
      if (response.data && response.data.content) {
        downloadFile(response.data.content, "invoices.zip");
      }
      return;
      //console.log(response);
      //setData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const signStatus = (
    status: string,
    invoide_id: number,
    token_str: string
  ) => {
    if (status == "COMPLETED") {
      verifyDigitalSign(invoide_id, token_str);
      // console.log("sign Completed")
    } else {
      console.log("sign aborted");
    }
  };

  const startDigitalSign = (invoice_id: number) => {
    let URL = INVOICE_URLS.SIGN_START;
    const subscription = post(URL, { id: invoice_id }).subscribe((response) => {
      let url =
        config.DIGI_SERVER_URL +
        "open/digital-sign?token=" +
        response.data.data;
      // window.location.href = url;
      openExternalWindow(url, (status) =>
        signStatus(status, invoice_id, response.data.data)
      );
      // openNewWindow(url);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const verifyDigitalSign = (id: any, token: string) => {
    let URL = INVOICE_URLS.SIGN_VERIFY;
    const subscription = post(URL, { id: id, token: token }).subscribe(
      (response) => {
        loadData();
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    if (token) {
      verifyDigitalSign(invoice_ret_id, token);
    } else {
      loadData();
    }
  }, [id]);

  const openInvoiceForm = () => {
    let options = {
      title: "New Invoice Form",
      content: <InvoiceAddingForm loadTableData={loadData} id={id} />,
      width: 90,
      className: "sd-efl-modal",
      closeBody: false,
    };
    openModal(options);
  };

  const EditInvoiceForm = (data: any) => {
    let URL = INVOICE_URLS.GET_ONE_DETAILS;
    const subscription = post(URL, { id: data["ID"] }).subscribe((response) => {
      let options = {
        title: ` ${data.hub_id} - ${data.invoice_number}  `,
        content: (
          <InvoiceAddingForm
            loadTableData={loadData}
            id={id}
            dataIn={response.data}
          />
        ),
        width: 80,
        className: "sd-efl-modal",
        closeBody: false,
      };
      openModal(options);
    });
    return () => subscription.unsubscribe();
  };

  const InvoiceNumberUpdateForm = (_dt: any) => {
    let URL = INVOICE_URLS.GET_ONE_DETAILS;
    const subscription = post(URL, { id: _dt["ID"] }).subscribe((response) => {
      let options = {
        title: ` ${_dt.hub_id} - ${_dt.vendor_company}  `,
        content: (
          <>
            <InvoiceNumberUpdate
              loadTableData={loadData}
              dataIn={response.data}
            />
          </>
        ),
        width: 60,
        className: "sd-efl-modal",
        closeBody: false,
      };
      openModal(options);
    });
    return () => subscription.unsubscribe();
  };

  const openForm = (data: any) => {
    let URL = INVOICE_URLS.GET_ONE_DETAILS;
    const subscription = post(URL, { id: data["ID"] }).subscribe((response) => {
      let options = {
        title: ` ${data.hub_id} - ${data.invoice_number}  `,
        content: <InvoiceVendorDetailsTable dataIn={response.data} />,
        width: 60,
        className: "sd-efl-modal",
        closeBody: false,
      };
      openModal(options);
    });
    return () => subscription.unsubscribe();
  };
  const handleDelete = (rowData: any) => {
    //console.log("Delete action for row:", rowData);
  };

  const openInvoiceRemarksForm = (_id: number, remarks: string) => {
    let options = {
      title: "Invoice Remarks",
      content: (
        <InvoiceRemarks loadTableData={loadData} id={_id} remarks={remarks} />
      ),
      width: 50,
      className: "sd-efl-modal",
      closeBody: false,
    };
    openModal(options);
  };

  const cancelButtons = [
    {
      label: "View",
      type: "icon",
      leftIcon: "fa fa-eye",
      classList: ["smart-efl-table-view-icon", ""],
      onClick: (data: any) => {
        openForm(data);
      },
    },
  ];
  const buttons = [
    {
      label: "View",
      type: "icon",
      leftIcon: "fa fa-eye",
      classList: ["smart-efl-table-view-icon", ""],
      onClick: (data: any) => {
        openForm(data);
      },
    },
    {
      label: "View",
      type: "icon",
      leftIcon: "fa fa-trash",
      classList: ["has-text-danger", ""],
      onClick: (data: any) => {
        openDeleteModal(data["ID"]);
      },
      hideFunction: (data: any) => {
        return data["status"] >= 5 ? true : false;
      },
    },
    {
      label: "View",
      type: "icon",
      leftIcon: "fa fa-times-circle",
      classList: ["has-text-warning-dark", ""],
      onClick: (data: any) => {
        openCancelModal(data["ID"]);
      },
      hideFunction: (data: any) => {
        return data["status"] === 5 || data["status"] === 10 ? false : true;
      },
    },
    {
      label: "View",
      type: "icon",
      leftIcon: "fa fa-mobile",
      classList: ["has-text-warning", ""],
      onClick: (dat: any) => {
        InvoiceNumberUpdateForm(dat);
      },
      hideFunction: (data: any) => {
        return data["status"] >= 5 ? true : false;
      },
    },
    {
      label: "View",
      type: "icon",
      leftIcon: "fa-file-pdf-o",
      classList: ["smart-efl-table-view-icon has-text-danger", ""],
      onClick: (data: any) => {
        downloadInvoice(data["ID"]);
      },
    },
    {
      label: "Sign",
      type: "icon",
      leftIcon: "fa fa-pencil",
      classList: ["smart-efl-table-view-icon has-text-success", ""],
      onClick: (data: any) => {
        EditInvoiceForm(data);
      },
      hideFunction: (data: any) => {
        return data["invoice_type"] == 2 ? false : true;
      },
    },
    {
      label: "Sign",
      type: "icon",
      leftIcon: "fa fa-play",
      classList: ["smart-efl-table-view-icon", ""],
      onClick: (data: any) => {
        startDigitalSign(data["ID"]);
      },
      hideFunction: (data: any) => {
        return data["status"] >= 5 || data["invoice_type"] == 2 ? false : true;
      },
    },
    {
      label: "View",
      type: "icon",
      leftIcon: "fa-file",
      classList: ["smart-efl-table-view-icon has-text-link", ""],
      onClick: (data: any) => {
        openInvoiceRemarksForm(data["ID"], data["remarks"]);
      },
    },
  ];

  const statusTags = [
    { value: 0, label: "Generated", class: "has-text-link" },
    { value: 5, label: "E-INVOICE", class: "has-text-primary" },
    { value: 10, label: "DIGITALLY SIGNED", class: "has-text-success" },
  ];

  const amountDisplay = (row: any) => {
    return (
      <>
        <div>{formatCurrency(row?.total_amount)}</div>
      </>
    );
  };
  const options = [
    { value: 1, label: "Automatic" },
    { value: 2, label: "Manual Invoice" },
    { value: 3, label: "Credit Note" },
  ];
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "3" },
    {
      title: "Invoice Type",
      index: "invoice_type",
      width: "8",
      type: "tags",
     tags: options
    },
    {
      title: "City",
      index: "office_city",
      width: "8",
    },
    {
      title: "Hub",
      index: "hub_id",
      width: "10",
    },

    {
      title: "Invoice Number",
      index: "invoice_number",
      width: "10",
    },
    {
      title: "Customer",
      index: "vendor_company",
      width: "10",
    },
    {
      title: "Total Amount",
      index: "total_amount",
      width: "10",
      valueFunction: amountDisplay,
    },
    {
      title: "ACK No",
      index: "ack_no",
      width: "10",
      valueFunction: (data) => {
        return data["status"] >= 5 ? (
          <span
            className="has-text-link sd-cursor"
            onClick={() => {
              downloadInvoice(data["ID"]);
            }}
          >
            {data["ack_no"]}
          </span>
        ) : null;
      },
    },
    {
      title: "Status",
      index: "status",
      width: "8",
      type: "tags",
      tags: statusTags,
    },
    {
      title: "Details",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "10",
    },
  ];
  const deleteData_new = (id: any) => {
    const subscription = post(INVOICE_URLS.DELETE_NEW_INVOICE, { bill_id: id }).subscribe(
      (response) => {
        showAlertAutoClose("Deleted Successfully...", "success");
        closeModal();
        loadData();
        // setLoading(false);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const openDeleteModal_Modal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i>  Deletion!
        </span>
      ),
      alertFunction: (option) => {
        if (option == "yes") {
          deleteData_new(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to delete this Automatic Invoice? This action cannot be
          reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };
  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-8",
      custom: <TabsComponent />,
    },
    {
      type: "BUTTONS",
      widthClass: "is-1",
      align: "CENTER",
      buttons: [{ type: "FILTER" }],
    },
    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
  ];

  const filterFields: SmartFormInterFace.SmartFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: "12",
      name: "hub_id",
      element: { label: "Hub" },
    },
    {
      type: "TEXT_BOX",
      width: "12",
      name: "invoice_number",
      element: { label: "Invoice Number" },
    },
    {
      type: "TEXT_BOX",
      width: "12",
      name: "vendor_company",
      element: { label: "Customer" },
    },
  ];
  const cancelTableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-9",
      custom: (
        <div className="is-flex is-align-items-center" style={{ gap: "0.4rem" }}>
          <TabsComponent />
          <SmartSoftButton
            label=""
            leftIcon="fa fa-download"
            classList={["smart-third-button"]}
            onClick={downloadZip}
          />
        </div>
      ),
    },
    {
      type: "BUTTONS",
      widthClass: "is-1",
      align: "CENTER",
      buttons: [{ type: "FILTER" }],
    },
    {
      type: "SEARCH",
      widthClass: "is-2",
      align: "JUSTIFY",
    },
  ];

  const cancelColumns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "3" },
    {
      title: "City",
      index: "office_city",
      width: "8",
    },
    {
      title: "Hub",
      index: "hub_id",
      width: "10",
    },

    {
      title: "Invoice Number",
      index: "invoice_number",
      width: "10",
    },
    {
      title: "Serial No",
      index: "invoice_serial_number",
      width: "6",
    },
    {
      title: "State",
      index: "state_name",
      width: "5",
    },
    {
      title: "Customer",
      index: "vendor_company",
      width: "10",
    },
    {
      title: "Total Amount",
      index: "total_amount",
      width: "10",
      valueFunction: amountDisplay,
    },
    {
      title: "ACK No",
      index: "ack_no",
      width: "10",
      valueFunction: (data) => {
        return data["status"] >= 5 ? (
          <span
            className="has-text-link sd-cursor"
            onClick={() => {
              downloadInvoice(data["ID"]);
            }}
          >
            {data["ack_no"]}
          </span>
        ) : null;
      },
    },
    {
      title: "Status",
      index: "status",
      width: "10",
      type: "tags",
      tags: statusTags,
    },
    {
      title: "Details",
      index: "action",
      type: "buttons",
      buttons: cancelButtons,
      width: "10",
    },
  ];

  const openImportForm = () => {
    let options = {
      title: "Invoice IRN/ACK import",
      content: <VendorDetailsImport loadData={loadData} id={id} />,
      width: 50,
      className: "sd-efl-modal",
      closeBody: false,
    };
    openModal(options);
  };
  const navigateBack = () => {
    navigate(-1);
  };
  const BillInformation = () => {
    return (
      <>
        <div className="columns is-multiline">
          <div className="column is-8 is-flex">
            {" "}
            <div
              className=" mt-1 has-text-link is-clickable is-size-5 "
              onClick={navigateBack}
            >
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
            </div>
            <p className="is-size-4 is-italic has-text-link ml-4">
              Bill Details
            </p>
            {/* <TabsComponent/> */}
          </div>

          <div className="column is-4">
            <div className="is-flex is-justify-content-flex-end">
              <SmartSoftButton
                label="Refresh"
                onClick={() => refresh()}
             leftIcon="fa fa-refresh"
                classList={["smart-third-button mr-2"]}
              />

              <>
                <SmartSoftButton
                  label="Export"
                  onClick={() => exportExcel()}
                  leftIcon="fa fa-cloud-upload"
                  classList={["smart-third-button mr-2"]}
                />
                <SmartSoftButton
                  label="Import"
                  onClick={() => openImportForm()}
                  leftIcon="fa fa-cloud-download"
                  classList={["smart-third-button"]}
                />
              </>
            </div>
          </div>
          <div className="column is-12">
            <div className="efl-bill-info-bar">
              <div className="efl-bill-info-item">
                <span className="efl-bill-label">Start Date</span>
                <span className="efl-bill-value">
                  {changeDateTimeZoneFormat(data?.bill_start_date, "DD-MM-YYYY")}
                </span>
              </div>
              <div className="efl-bill-info-sep" />
              <div className="efl-bill-info-item">
                <span className="efl-bill-label">End Date</span>
                <span className="efl-bill-value">
                  {changeDateTimeZoneFormat(data?.bill_end_date, "DD-MM-YYYY")}
                </span>
              </div>
              <div className="efl-bill-info-sep" />
              <div className="efl-bill-info-item">
                <span className="efl-bill-label">GST (Rs)</span>
                <span className="efl-bill-value">{formatCurrency(data?.gst_amount)}</span>
              </div>
              <div className="efl-bill-info-sep" />
              <div className="efl-bill-info-item">
                <span className="efl-bill-label">Total (Rs)</span>
                <span className="efl-bill-value efl-bill-total">{formatCurrency(data?.total_amount)}</span>
              </div>
            </div>
          </div>

          {/* State filter chips + action buttons in one row */}
          <div className="column is-12">
            <div className="is-flex is-align-items-center is-justify-content-space-between">
              {/* Left: state filter chips */}
              <div className="is-flex is-align-items-center" style={{ gap: "0.4rem", flexWrap: "wrap" }}>
                {getStateGroups().map((group) => {
                  const isActive = selectedState === group.state_name && selectedRange === group.range;
                  return (
                    <div
                      key={group.state_name}
                      className="is-clickable"
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "0.25rem",
                        border: `1.5px solid ${isActive ? "#3273dc" : "#aaa"}`,
                        borderRadius: "4px", padding: "3px 10px",
                        background: isActive ? "#ebf3ff" : "#fff",
                        userSelect: "none", fontSize: "0.75rem",
                      }}
                      onClick={() => {
                        if (isActive) { setSelectedState(null); setSelectedRange(null); }
                        else { setSelectedState(group.state_name); setSelectedRange(group.range); }
                      }}
                    >
                      <span className="has-text-weight-semibold has-text-link">
                        {group.state_name} ({group.count})
                      </span>
                      <span style={{ color: isActive ? "#257942" : "#333" }}>{group.range}</span>
                    </div>
                  );
                })}
                {(selectedState || selectedRange) && (
                  <span
                    className="tag is-small is-danger is-light is-clickable"
                    onClick={() => { setSelectedState(null); setSelectedRange(null); }}
                  >
                    <i className="fa fa-times" />
                  </span>
                )}
              </div>

              {/* Right: Add / Delete / Download buttons */}
              <div className="is-flex is-align-items-center" style={{ gap: "0.4rem" }}>
                <SmartSoftButton
                  label="Add"
                  leftIcon="fa fa-plus"
                  classList={["smart-third-button"]}
                  onClick={openInvoiceForm}
                />
                <SmartSoftButton
                  label="Auto invoice Delete"
                  leftIcon="fa fa-trash"
                  classList={["smart-third-button"]}
                  onClick={() => openDeleteModal_Modal(id)}
                />
                <SmartSoftButton
                  label="Download"
                  leftIcon="fa fa-download"
                  classList={["smart-third-button"]}
                  onClick={downloadZip}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {BillInformation()}

      {activeIndex == "1" && (
        <div className="is-size-7 invoice-vendor-table">
          <SmartTable
            columns={columns}
            data={getFilteredInvoiceData()}
            tableTop={tableTop}
            filterFields={filterFields}
            tableProps={{
              className: `is-hoverable is-striped p-0 is-narrow smart-small-table ${
                !isDark ? "smart-efl-table" : ""
              }`,
              isResponsive: true,
              searchPlaceHolder: "Search",
            }}
            paginationProps={{ pageSize: 10 }}
          />
        </div>
      )}
      {activeIndex == "2" && (
        <div className="is-size-7 invoice-vendor-table">
          <SmartTable
            columns={cancelColumns}
            data={data?.invoice_data_cancelled || []}
            tableTop={cancelTableTop}
            tableProps={{
              className: `is-hoverable is-striped is-narrow smart-small-table ${
                !isDark ? "smart-efl-table" : ""
              }`,
              isResponsive: true,
              searchPlaceHolder: "Search",
            }}
            paginationProps={{ pageSize: 10 }}
          />
        </div>
      )}
    </>
  );
};

export default VendorWiseInformation;
